<template>
  <span>
    <select v-model="selectedName" class="name">
      <option disabled value="">Choose an Indicator</option>
      <option v-if="!nameFromInd[value]" v-bind:value="value">{{value}}</option>
      <option
        v-for="name in names"
        v-bind:key="name"
        v-bind:value="name">{{name}}
      </option>
    </select>
    <select v-model="selectedYear" class="year">
      <option disabled value="">Year</option>
      <option v-if="years.length === 0" value="N/A">N/A</option>
      <option
        v-for="year in years"
        v-bind:key="year"
        v-bind:value="year">{{year}}
      </option>
    </select>
  </span>
</template>

<script>
export default {
  name: 'IndSelect',
  props: ['indFromName', 'value'],
  data: function () {
    return {
      selectedName: null,
      selectedYear: null,
    }
  },
  computed: {
    nameFromInd: function () {
      let out = {}
      for (let name of Object.keys(this.indFromName)) {
        for (let year of Object.keys(this.indFromName[name])) {
          out[this.indFromName[name][year]] = {
            name: name,
            year: year,
          }
        }
      }
      return out
    },
    names: function () {
      return Object.keys(this.indFromName).sort()
    },
    years: function () {
      if (this.indFromName[this.selectedName]) {
        return Object.keys(this.indFromName[this.selectedName]).sort()
      } else {
        return []
      }
    },
    selectedInd: function () {
      if (this.selectedName && this.selectedYear && this.indFromName[this.selectedName]) {
        return this.indFromName[this.selectedName][this.selectedYear]
      } else {
        return null
      }
    },
  },
  watch: {
    years: function () {
      if (this.years.length === 0) {
        this.selectedYear = 'N/A'
      } else if (!this.years.includes(this.selectedYear)) {
        this.selectedYear = this.years[0]
      }
    },
    selectedInd: function () {
      if (this.selectedInd && this.selectedInd !== this.value) {
        this.$emit('input', this.selectedInd)
      }
    },
    value: {
      immediate: true,
      handler: function () {
        let d = this.nameFromInd[this.value] || { name: this.value, year: 'N/A' }
        this.selectedName = d.name
        this.selectedYear = d.year
      },
    },
  },
}
</script>

<style scoped>
  select {
    border-color: #f3f3f3;
  }

  select:focus {
    outline: 0;
    border-color: black;
  }

  select.name {
    border-radius: 10px 0 0 10px;
    max-width: calc(100% - 4.1em);
    min-width: 0;
  }

  select.year {
    border-radius: 0 10px 10px 0;
  }

  select option{
    font-size: 1rem;
  }
</style>
